import React from 'react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './ui/dropdown-menu';
import { useLanguage, type Language } from './LanguageContext';

// Flag components as SVGs
const SpanishFlag = () => (
  <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="15" rx="2" fill="#C60B1E"/>
    <rect y="3.75" width="20" height="7.5" fill="#FFC400"/>
  </svg>
);

const AmericanFlag = () => (
  <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="15" rx="2" fill="#B22234"/>
    <rect y="1.15" width="20" height="1.15" fill="#FFFFFF"/>
    <rect y="3.46" width="20" height="1.15" fill="#FFFFFF"/>
    <rect y="5.77" width="20" height="1.15" fill="#FFFFFF"/>
    <rect y="8.08" width="20" height="1.15" fill="#FFFFFF"/>
    <rect y="10.38" width="20" height="1.15" fill="#FFFFFF"/>
    <rect y="12.69" width="20" height="1.15" fill="#FFFFFF"/>
    <rect width="8" height="8.08" fill="#3C3B6E"/>
    <g fill="#FFFFFF">
      <circle cx="1.5" cy="1.5" r="0.3"/>
      <circle cx="3" cy="1.5" r="0.3"/>
      <circle cx="4.5" cy="1.5" r="0.3"/>
      <circle cx="6" cy="1.5" r="0.3"/>
      <circle cx="2.25" cy="2.5" r="0.3"/>
      <circle cx="3.75" cy="2.5" r="0.3"/>
      <circle cx="5.25" cy="2.5" r="0.3"/>
      <circle cx="1.5" cy="3.5" r="0.3"/>
      <circle cx="3" cy="3.5" r="0.3"/>
      <circle cx="4.5" cy="3.5" r="0.3"/>
      <circle cx="6" cy="3.5" r="0.3"/>
      <circle cx="2.25" cy="4.5" r="0.3"/>
      <circle cx="3.75" cy="4.5" r="0.3"/>
      <circle cx="5.25" cy="4.5" r="0.3"/>
      <circle cx="1.5" cy="5.5" r="0.3"/>
      <circle cx="3" cy="5.5" r="0.3"/>
      <circle cx="4.5" cy="5.5" r="0.3"/>
      <circle cx="6" cy="5.5" r="0.3"/>
      <circle cx="2.25" cy="6.5" r="0.3"/>
      <circle cx="3.75" cy="6.5" r="0.3"/>
      <circle cx="5.25" cy="6.5" r="0.3"/>
    </g>
  </svg>
);

const ChevronDownIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6,9 12,15 18,9"></polyline>
  </svg>
);

interface LanguageSelectorProps {
  className?: string;
}

export function LanguageSelector({ className = "" }: LanguageSelectorProps) {
  const { language, setLanguage } = useLanguage();

  const languages = [
    {
      code: 'es' as Language,
      name: 'Español',
      flag: <SpanishFlag />
    },
    {
      code: 'en' as Language,
      name: 'English',
      flag: <AmericanFlag />
    }
  ];

  const currentLanguage = languages.find(lang => lang.code === language);

  const handleLanguageChange = (langCode: Language) => {
    setLanguage(langCode);
  };

  return (
    <div className={`relative ${className}`}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            className="flex items-center gap-2 h-9 px-3 rounded-lg hover:bg-gray-50 text-gray-700 transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
          >
            {currentLanguage?.flag}
            <ChevronDownIcon />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-40">
          {languages.map((lang) => (
            <DropdownMenuItem
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={`flex items-center gap-3 cursor-pointer ${
                language === lang.code ? 'bg-gray-50' : ''
              }`}
            >
              {lang.flag}
              <span className="text-sm font-medium">{lang.name}</span>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}